export default __webpack_public_path__ + "static/media/bank-card.4396039f.svg";